/**
 * Course thumbnails are shown at large size (emoji). If a URL was stored
 * (e.g. from an incorrectly labeled admin field), avoid rendering it as huge text.
 */
export function formatCourseThumbnail(thumbnail) {
  if (thumbnail == null || String(thumbnail).trim() === '') return '📚';
  const t = String(thumbnail).trim();
  if (/^https?:\/\//i.test(t) || /^www\./i.test(t)) return '📚';
  return t;
}

// More specific course topics come first so they win over generic keywords
// (e.g. an economics course mentioning "market" shouldn't match investing).
const TOPIC_ICON_RULES = [
  [/insurance|insure|premium|deductible|coverage|policy|liability/, 'course-insurance.svg'],
  [/crypto|cryptocurrency|bitcoin|ethereum|blockchain|web3|defi|nft/, 'course-cryptocurrency.svg'],
  [/macroeconom|macro\s*econ|ap\s*macro/, 'course-macroeconomics.svg'],
  [/microeconom|micro\s*econ|ap\s*micro/, 'course-microeconomics.svg'],
  [/budget|spend|expense|income|paycheck/, 'icon-budgeting.svg'],
  [/credit|debt|loan|card|borrow|interest/, 'icon-credit.svg'],
  [/invest|stock|market|portfolio|asset|retire|compound/, 'icon-investing.svg'],
  [/sav(e|ing)|bank|emergency fund|deposit/, 'icon-saving.svg'],
  [/tax|irs|deduction|w-?2|1040|withhold/, 'icon-taxes.svg'],
];

/**
 * Map a course to one of the branded topic icons (in /public) based on its
 * title/category/description. Returns the public path, or null when nothing
 * matches so callers can fall back to the emoji thumbnail.
 */
export function getCourseTopicIcon(course) {
  if (!course) return null;
  const haystack = `${course.title || ''} ${course.category || ''} ${course.description || ''}`.toLowerCase();
  for (const [pattern, icon] of TOPIC_ICON_RULES) {
    if (pattern.test(haystack)) return `${process.env.PUBLIC_URL || ''}/${icon}`;
  }
  return null;
}
